import moment from "moment";

import { useTranslation } from "react-i18next";
import Checklist from "../Checklist";
import { GET, newFetch, PUT } from "../../../../helpers/fetch";
import AlertService from "../../../../components/SweetAlert";

const SingleClockIn = ({
  user,
  isClockInToday,
  themeImages,
  masterClockInOutHandler,
  loading,
  lastRecentActivityIN,
  lastRecentActivityOUT,
  lastRecentActivityBreakIN,
  calculatedBreakTime,
  setAnswers,
  answers,
  checklist,
  attendanceLogs,
  isClockOutToday,
  defaultSiteData,
  selectedSchedule,
  overNightShift,
  isWithin5Hours,
  refreshScheduleData,
}) => {
  const { t } = useTranslation();
  const enableBreak = defaultSiteData?.enable_fix_break !== false;

  const handleMarkComplete = async () => {
    const isConfirmed = await AlertService.confirm(
      "Are you sure you want to proceed to the next shift?"
    );
    if (!isConfirmed) return;

    try {
      const api_path = `/associate/schedule/${selectedSchedule?.id}/mark_complete`;
      const response = await newFetch("PUT", api_path);

      if (response.success) {
        AlertService.success("Shift marked as complete successfully!");

        // Refresh the schedule data
        await refreshScheduleData();
      } else {
        AlertService.error("Failed to mark shift as complete.");
      }
    } catch (error) {
      console.error(error);
      AlertService.error("Error marking shift as complete.");
    }
  };

  return (
    <>
      {!isClockInToday() ? (
        <>
          <img
            src={themeImages.rocket}
            height={150}
            width={150}
            style={{
              marginTop: 20,
              marginHorizontal: 20,
              justifyContent: "center",
            }}
          />

          <div
            style={{
              width: "100%",
              paddingHorizontal: 20,
              marginTop: 20,
            }}
          >
            <button
              type="button"
              className="btn btn-design btn-brand btn-clockinout"
              onClick={() => {
                masterClockInOutHandler("clock in");
              }}
              disabled={loading}
            >
              {loading ? "Loading..." : "Clock In"}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="timeclock__container">
            <div className="timeclock__container-header">
              <p>IN</p>
              {!enableBreak && <p>BREAK</p>}
              <p>OUT</p>
            </div>
            <div className="timeclock__container-row">
              <p>
                {lastRecentActivityIN?.punchtime &&
                  moment(lastRecentActivityIN?.punchtime).format("HH:mm")}
              </p>
              {!enableBreak && (
                <div>
                  {lastRecentActivityBreakIN &&
                    (!calculatedBreakTime ? (
                      <div style={{ alignItems: "center" }}>
                        <p style={{ width: "100%" }}>
                          {lastRecentActivityBreakIN?.punchtime &&
                            moment(lastRecentActivityBreakIN.punchtime).format(
                              "HH:mm"
                            )}{" "}
                          - now
                        </p>
                      </div>
                    ) : (
                      <p style={{ width: 100, color: "#888A8C" }}>
                        {calculatedBreakTime}
                      </p>
                    ))}

                  {!calculatedBreakTime && (
                    <button
                      className={`${
                        !lastRecentActivityBreakIN
                          ? "btn btn-break"
                          : "btn btn-break-red"
                      }`}
                      onClick={() => {
                        masterClockInOutHandler(
                          !lastRecentActivityBreakIN ? "break in" : "break out"
                        );
                      }}
                    >
                      <img
                        src={`${
                          !lastRecentActivityBreakIN
                            ? themeImages.coffeeBreak
                            : themeImages.coffeeBreakRed
                        }`}
                        height={30}
                        width={30}
                        style={{
                          marginRight: 10,
                          justifyContent: "center",
                        }}
                      />
                      <span
                        className={`${
                          !lastRecentActivityBreakIN
                            ? "label-break"
                            : "label-break-red"
                        }`}
                      >
                        {!lastRecentActivityBreakIN
                          ? "Start Break"
                          : "Stop Break"}
                      </span>
                    </button>
                  )}
                </div>
              )}
              <p>
                {lastRecentActivityOUT?.punchtime &&
                  moment(lastRecentActivityOUT?.punchtime).format("HH:mm")}
              </p>
            </div>
          </div>

          {!isClockOutToday() && checklist.length !== answers.length && (
            <Checklist
              setAnswers={setAnswers}
              answers={answers}
              checklist={checklist}
            />
          )}

          {!isClockOutToday() && (
            <div
              style={{
                width: "100%",
                paddingHorizontal: 20,
                marginTop: 20,
              }}
            >
              <button
                type="button"
                className="btn btn-design btn-brand btn-clockinout"
                onClick={() => {
                  checklist.length === answers.length &&
                    masterClockInOutHandler("clock out");
                }}
                disabled={
                  loading
                    ? loading
                    : checklist.length === answers.length
                    ? false
                    : true
                }
              >
                {loading ? "Loading..." : "Clock Out"}
              </button>
              {checklist.length !== answers.length && (
                <p style={{ marginTop: 15 }}>
                  To enable the clock-out button, please ensure that all{" "}
                  <b>Appointed Checklist</b> questions are specified.
                </p>
              )}
            </div>
          )}

          {/* Add the Mark Complete link here, similar to MultipleClockIn */}
          {isClockInToday() && overNightShift && isWithin5Hours && (
            <div
              style={{
                width: "100%",
                paddingHorizontal: 20,
                marginTop: 10,
                textAlign: "center",
              }}
            >
              <span
                style={{
                  color: "#007bff",
                  textDecoration: "underline",
                  cursor: "pointer",
                  paddingTop: "1rem",
                  display: "inline-block",
                }}
                onClick={handleMarkComplete}
              >
                Click here to proceed to next shift.
              </span>
            </div>
          )}

          <div className="timeclock__recentactivities-container">
            <h3 className="mb-2">Recent Activity</h3>
            {attendanceLogs.length > 0 &&
              attendanceLogs.map((item, index) => (
                <div key={index} className="timeclock__recentactivities-row">
                  <div
                    className="rounded-circle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: 12,
                      width: "30%",
                      backgroundColor: ["checkin", "checkout"].includes(
                        item.type
                      )
                        ? "rgba(255, 191, 83, 0.25)"
                        : "rgba(81, 86, 190, 0.25)",
                      borderColor: ["checkin", "checkout"].includes(item.type)
                        ? "rgba(255, 191, 83, 0.25) solid 1px"
                        : "rgba(81, 86, 190, 0.25) solid 1px",
                      height: 45,
                      width: 53,
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        zIndex: 1,
                      }}
                    >
                      {item.type === "checkin"
                        ? "IN"
                        : item.type === "checkout"
                        ? "OUT"
                        : item.type === "breakin"
                        ? "BRIN"
                        : "BROUT"}
                    </p>
                  </div>
                  {attendanceLogs.length !== index + 1 && (
                    <svg
                      height="70%"
                      width="2"
                      style={{
                        position: "relative",
                        top: 45,
                        left: -28,
                      }}
                    >
                      <line
                        x1="1"
                        y1="0"
                        x2="1"
                        y2="85%"
                        stroke="#ccc"
                        strokeWidth="2"
                        strokeDasharray="4,4"
                      />
                    </svg>
                  )}
                  <div className="timeclock__recentactivities-logs">
                    <p>
                      {moment(item.punchtime).format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                    <p style={{ fontWeight: 400, color: "#495057" }}>
                      {user?.full_name}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        margin: "10px 0px",
                      }}
                    >
                      <p style={{ marginRight: 20 }}>Location: </p>
                      <p style={{ fontWeight: 400 }}>{item?.address || "NA"}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default SingleClockIn;
